import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as XLSX from '../../../../../xlsx';
import { CommunicationProxyService } from '../../../../services/communication-proxy.service';
import { LoginService } from '../../../../services/login.service';
import { StringTableService } from '../../../../services/string-table.service';
import { Accordion, AccordionRow, AccordionRowTypes } from '../../../data-accordion/data-accordion.component';
import { PageViewComponent } from '../../../page-view/page-view.component';
import { Table, Types } from '../../../table/table.component';
import { ButtonModel } from '../../../tg-button/tg-button.component';
import { activeReportingPageEnum } from '../reporting/reporting.component';

@Component({
  selector: 'app-score-details-report',
  templateUrl: './score-details-report.component.html',
  styleUrls: ['./score-details-report.component.scss']
})
export class ScoreDetailsReportComponent extends PageViewComponent implements OnInit {

  public coursePageTitle: string;
  public detailedCoursePageTitle: string;
  public pageDesc: string;
  public pageDescCont: string;
  public courseName: string;
  public assignmentTitle: string;

  detailsHeader: Table[];
  detailsTable: Table[][];
  detailsSummaryHeader: Table[];
  detailsSummaryTable: Table[][];

  public backBtnData: ButtonModel = { name: '', icon: '' };
  public csvBtnData: ButtonModel = { name: '', icon: '' };
  public excelBtnData: ButtonModel = { name: '', icon: '' };

  noOfColumns: number;

  @Input() autoTrainingId: string;

  @Input() autoTrainingName: string;

  @Output() backToReport = new EventEmitter<any>();

  /**
   * An array of array containing the data which is to be sent to sheet js for creating
   * a excel file.
   */
  private dataForSheetJs: any[][];

  private xlsxWritingOptions: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };

  /**
   * The file name of the sheet generated.
   */
  private excelFileName = '';

  /**
   * The rows which are shown in excel.
   */
  private tableRowsForExcel: Table[][] = [];

  /**
   * The color which should be applied to the 1st row in the created excel.
   */
  private headerHexColorName = '';

  public totalParentAccordions: Accordion[] = [];
  public totalChildAccordians: Accordion[] = [];
  dataAccordion: Accordion;
  header: Table[];
  tableHeaderCols: string[] = [];
  private getAssignmentsEndPoint: string;
  protected linkStr: string;
  public isSkillDetails: boolean;

  constructor(ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.totalChildAccordians = [];
    this.totalParentAccordions = [];
    this.header = [];
    this.isSkillDetails = false;
  }

  ngOnInit() {
    this.initView();
    this.getAssignments();
    this.createDetailsSummaryTable();
    this.createDetailsTable();
  }

  initView() {
    this.coursePageTitle = this.stringTableService.getString('report-courses', 'coursePageTitle');
    this.detailedCoursePageTitle = this.stringTableService.getString('report-courses', 'detailedCoursePageTitle');
    this.pageDesc = this.stringTableService.getString('report-courses', 'pageDesc');
    this.pageDescCont = this.stringTableService.getString('report-courses', 'pageDescCont');
    this.courseName = this.stringTableService.getString('labels', 'excelTitle');
    this.assignmentTitle = this.stringTableService.getString('report-courses', 'assignmentTitle');
    this.tableHeaderCols = this.stringTableService.getArrayOfStrings('report-courses', 'tableHeaders');
    this.getAssignmentsEndPoint = this.stringTableService.getEndpoint('GetAssignments');
    this.linkStr = this.stringTableService.getString('labels', 'assignmentTitle');
    this.headerHexColorName = this.stringTableService.getString('colors', 'excelHeaderColumnColor');
    this.excelFileName = this.stringTableService.getString('fileNames', 'excelFileName');
    this.backBtnData = {
      name: this.stringTableService.getString('labels', 'back'),
      icon: ''
    };
    this.csvBtnData = {
      name: this.stringTableService.getString('report-courses', 'exportCSV'),
      icon: ''
    };
    this.excelBtnData = {
      name: this.stringTableService.getString('report-courses', 'exportExcel'),
      icon: ''
    };
  }

  createDetailsSummaryTable() {
    this.detailsSummaryHeader = [
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'totalQuestions')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'correct')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'incorrect')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'incomplete')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'totalTime')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'score'))
    ];

    this.detailsSummaryTable = [[
      new Table(Types.TEXT, 'table-header', '8'),
      new Table(Types.TEXT, 'table-header', '0'),
      new Table(Types.TEXT, 'table-header', '1'),
      new Table(Types.TEXT, 'table-header', '7'),
      new Table(Types.TEXT, 'table-header', '01:05:10'),
      new Table(Types.TEXT, 'table-header', '0/80')
    ]];
  }

  createDetailsTable() {
    this.detailsHeader = [
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'serial')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'task')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'result')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'timeTaken')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('report-courses', 'userActions'))
    ];

    this.detailsTable = [[
      new Table(Types.TEXT, 'table-header', '1'),
      new Table(Types.TEXT, 'table-header', 'Create blank workbook'),
      new Table(Types.TEXT, 'table-header', 'Incorrect'),
      new Table(Types.TEXT, 'table-header', '01:05:10'),
      new Table(Types.TEXT, 'table-header', 'Click-stream is not available')
    ], [
      new Table(Types.TEXT, 'table-header', '2'),
      new Table(Types.TEXT, 'table-header', 'Create blank workbook'),
      new Table(Types.TEXT, 'table-header', 'Incorrect'),
      new Table(Types.TEXT, 'table-header', '01:05:10'),
      new Table(Types.TEXT, 'table-header', 'Click-stream is not available')
    ], [
      new Table(Types.TEXT, 'table-header', '3'),
      new Table(Types.TEXT, 'table-header', 'Create blank workbook'),
      new Table(Types.TEXT, 'table-header', 'Incorrect'),
      new Table(Types.TEXT, 'table-header', '01:05:10'),
      new Table(Types.TEXT, 'table-header', 'Click-stream is not available')
    ]
    ];

    const headerClone = JSON.parse(JSON.stringify(this.detailsHeader));
    this.noOfColumns = headerClone.length;
    this.dataForSheetJs = this.parseDataForSheetJs([headerClone]);
  }

  private parseDataForSheetJs(tableData: any): any[][] {
    const parsedDataForSheet: any[][] = [[]];
    let i = 0, j = 0;
    for (const row of tableData) {
      parsedDataForSheet[i] = [];
      for (const data of row) {
        if ((j === 0 && data.title === '') || (j === this.noOfColumns)) {
          continue;
        }
        if (data.type !== 1 || data.type !== 6 || data.type !== 5) {
          parsedDataForSheet[i][j] = data.title;
        }
        j += 1;
      }
      j = 0;
      i += 1;
    }
    return parsedDataForSheet;
  }

  private saveToExcelClicked() {
    this.tableRowsForExcel = this.detailsTable;
    if (this.tableRowsForExcel.length > 0) {
      this.dataForSheetJs.splice(1, this.dataForSheetJs.length - 1);
      const tableClone = JSON.parse(JSON.stringify(this.tableRowsForExcel));
      Array.prototype.push.apply(this.dataForSheetJs, this.parseDataForSheetJs(tableClone));

      const workSheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.dataForSheetJs);
      let noOfHeadersFormated = 0;
      for (const cell in workSheet) {
        if (workSheet.hasOwnProperty(cell)) {
          if (cell === '!ref') {
            continue;
          }
          noOfHeadersFormated += 1;
          if (noOfHeadersFormated !== this.noOfColumns + 1) {
            workSheet[cell].bold = true;
            workSheet[cell].fillColor = true;
          } else {
            break;
          }
        }
      }

      /* generate workbook and add the worksheet */
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      (workbook as any).headerColor = this.headerHexColorName;
      XLSX.utils.book_append_sheet(workbook, workSheet, 'Sheet1');

      /* save to file */
      const workBookOutputBuffer: ArrayBuffer = XLSX.write(workbook, this.xlsxWritingOptions);
      saveAs(new Blob([workBookOutputBuffer], { type: 'application/octet-stream' }), this.excelFileName);
    }
  }
  getAssignments() {
    this.getDataFromApi(this.getAssignmentsEndPoint, {})
      .subscribe(this.handleAssignmentData.bind(this),
        this.handleSubscriptionError.bind(this, this.getAssignments.bind(this), false));
  }

  handleAssignmentData(data) {
    this.hideLoader();
    const dataFromApi = data.assignments;
    this.setAccordianData(dataFromApi);
  }

  setAccordianData(assignmentData) {
    for (let i = 0; i < this.tableHeaderCols.length; i++) {
      this.header.push(new Table(Types.TEXT, 'table-header', this.tableHeaderCols[i]));
    }

    for (const assignment of assignmentData) {
      const parentAccordionHeader = new AccordionRow(
        AccordionRowTypes.TITLE_DESC, assignment.assignmentName, assignment.assignmentDescription);
      for (const skill of assignment.skills) {
        const childAccordionHeader = new AccordionRow(AccordionRowTypes.PERCENT_BAR, skill.skillName, skill.skillCompletion);
        const childAccordianData = new AccordionRow(AccordionRowTypes.TABLE, this.header, this.setTableData(skill.scoreSummary));
        this.dataAccordion = new Accordion(childAccordionHeader, childAccordianData);
        this.totalChildAccordians.push(this.dataAccordion);
      }
      const parentAccordionData = new AccordionRow(AccordionRowTypes.ACCORDION, this.totalChildAccordians);
      this.dataAccordion = new Accordion(parentAccordionHeader, parentAccordionData);
      this.totalParentAccordions.push(this.dataAccordion);
    }
  }

  setTableData(data) {
    const tableData: Table[][] = [];
    for (const row of data) {
      const tableRow = [];
      tableRow.push(new Table(Types.TEXT, 'table-data', '1'));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.attemptDate));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.questionCount));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.scoreObtained + '/' + row.totalScore));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.correctResponse));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.incorrectResonse));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.skippedQuestionCount));
      tableRow.push(new Table(Types.LINK_ICON, 'tg-arrow-up2', this.linkStr));
      tableData.push(tableRow);
    }
    return tableData;
  }

  onBackClick(event) {
    this.backToReport.emit({ 'activePage': activeReportingPageEnum.reportingHome, 'autoTestId': this.autoTrainingId });
  }

  tableLinkClicked() {
    this.isSkillDetails = true;
  }

  backBtnClicked() {
    this.isSkillDetails = false;
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/reporting-training/score-details-report/score-details-report.component.ts